export const AUTHORISE_TREATMENT = "authoriseTreatment";
export const CLAIM_BACK = "claimBack";

export const MUSCLES_BONES_JOINTS_CONDITION = "isMusclesBonesJointsCondition";
export const OTHER_CONDITION = "otherCondition";

export const MEDICAL_TREATMENT = "medicalTreatment";
export const IN_PATIENT_NHS = "inPatientNhs";
export const DENTAL_OR_OPTICAL = "dentalOrOptical";
export const PRIVATE_GP_FEES = "privateGpFees";
export const CHIROPODY_PODIATRY = "chiropodyPodiatry";
export const CHILD_BIRTH = "childBirth";
export const NHS_CHEMO_RADIO = "nhsChemoRadio";

export const CHEMOTHERAPY = "chemotherapy";
export const RADIOTHERAPY = "radiotherapy";

export const CHOSEN_CLAIM_TYPE = "chosenClaimType";
export const CLAIM_BACK_OPTIONS_CONTENT = "claimBackOptionsContent";
export const IS_NEW_CLAIM_CONDITION_CONTENT = "isNewClaimConditionContent";
export const DO_YOU_NEED_AUTHORISATION_CONTENT =
  "doYouNeedAuthorisationContent";
export const CHEMO_RADIO_THERAPY_CONTENT = "chemoRadioTherapyContent";
export const NISSAN = '89180';
export const BANK_OF_AMERICA = '89125';
export const AGE_SIXTEEN = 16;
export const AGE_SEVENTEEN = 17;
export const DATA_PER_PAGE = 4;
